(async () => {
  const rating = await fetch('https://www.fpapplications.com/trustpilot', {
    headers: {
      'x-store-id': 1,
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((data) => data.rating)
    .catch(() => {});
  if (rating) {
    document.querySelector('.js-trustpilot-rating').innerText = rating;
  }
})();
